document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.querySelector(".a_header__hamburger");
  const modal = document.querySelector(".a_header__modal");
  const closeBtn = document.querySelector(".a_header__close");
  const bar = document.querySelector(".announcement-bar-section");

  const overlay = document.querySelector(".a_overlay");


  if (!hamburger || !modal || !closeBtn) return;

  // 開く
  hamburger.addEventListener("click", () => {
    modal.classList.add("is-open");
    bar.classList.add("is-hidden");
    document.body.classList.add("is-locked");
    overlay.classList.add("is-active");
  });

  // 閉じる
  closeBtn.addEventListener("click", () => {
    modal.classList.remove("is-open");
    bar.classList.remove("is-hidden");
    document.body.classList.remove("is-locked");
    overlay.classList.remove("is-active");
  });
});
